module.exports = __webpack_public_path__ + "img/pellets-sackware.c5a466d.webp";